export default interface GalleryFlag {
  key: string;
  type: string;
  order: number;
  label: string;
  longLabel?: string;
  restriction?: {
    acceptedFiles: string[];
    label: string;
  };
  tags: string[];
}

export const PICTURE: GalleryFlag = {
  key: "picture",
  type: "PICTURE",
  order: 3,
  label: "Picture",
  tags: ["picture"],
  restriction: {
    acceptedFiles: ["image/*"],
    label: "images only",
  },
};

export const DOCUMENT: GalleryFlag = {
  key: "document",
  type: "DOCUMENT",
  order: 3,
  label: "Document",
  tags: ["document"],
};

export const TDS: GalleryFlag = {
  key: "TDS",
  type: "TDS",
  order: 1,
  label: "TDS",
  restriction: {
    acceptedFiles: [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
    ],
    label: "doc, docx, pdf",
  },
  tags: ["TDS"],
};

export const OTHER: GalleryFlag = {
  key: "others",
  type: "OTHER",
  order: 3,
  label: "Others",
  longLabel: "Attachment",
  tags: ["others"],
};
